export enum TemplateGroup {
  KamEmailConfirm = 'kam-email-confirm',
  KamEmailRequest = 'kam-email-request',
  KamEmailCancel = 'kam-email-cancel',
  WhatsAppFeedback = 'whatsapp-feedback',
  WhatsAppFinalQuery = 'whatsapp-final-query',
  WhatsAppInterviewConfirmation = 'whatsapp-interview-confirmation',
  WhatsAppInterviewReminder = 'whatsapp-interview-reminder',
  WhatsAppInterviewRequest = 'whatsapp-interview-request',
  WhatsAppOnboarding = 'whatsapp-onboarding',
  WhatsAppSpecial = 'whatsapp-special',
}

export const KAM_EMAIL_TEMPLATES_GROUPS = [TemplateGroup.KamEmailConfirm, TemplateGroup.KamEmailRequest, TemplateGroup.KamEmailCancel];
export const WHATSAPP_TEMPLATES_GROUPS = [
  TemplateGroup.WhatsAppFeedback,
  TemplateGroup.WhatsAppFinalQuery,
  TemplateGroup.WhatsAppInterviewConfirmation,
  TemplateGroup.WhatsAppInterviewReminder,
  TemplateGroup.WhatsAppInterviewRequest,
  TemplateGroup.WhatsAppOnboarding,
  TemplateGroup.WhatsAppSpecial,
];
